<template>
  <Card>
    <h3 slot="title">
      <span>{{ deptName }}数据看板</span>
      <span class="ml20">{{ userName }}，{{ timeSlot }}好！{{ dateStr }}</span>
      <el-button slot="btn" icon="el-icon-refresh" @click="refresh">刷新</el-button>
    </h3>
    <div slot="content" class="homewrap" v-loading="loading">
      <!-- <el-button @click="upload">导入医保目录</el-button> -->
      <!-- <h3>经营概况</h3>
      <div class="page section">
        <el-button type="text" @click="getStatistical(time.today, time.today)">今天</el-button>
        <el-button type="text" @click="getStatistical(time.yesterday, time.yesterday)">昨天</el-button>
        <el-button type="text" @click="getStatistical(time.monday, time.sunday)">本周</el-button>
        <el-button type="text" @click="getStatistical(time.firstday, time.lastday)">本月</el-button>
        <el-date-picker v-model="timeRange" type="daterange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" value-format="yyyy-MM-dd" />
        <el-button type="primary" @click="getStatistical(timeRange[0], timeRange[1])"
          :disabled="timeRange == ''">查询</el-button> -->
      <!-- 表格数据 -->
      <!-- <div class="table-list">
          <div class="table-item">
            <div class="left">
              <span class="iconfont icon-icon-test1"></span>
              <h3>收入总额</h3>
            </div>
            <div class="right">
              <ul>
                <li>营业总收入(不含挂号费)</li>
                <li>客单量</li>
                <li>客单价</li>
                <li>毛利额</li>
                <li>毛利率</li>
              </ul>
              <ul>
                <li>{{ formatNumber(income.totalPrice || 0) }} 元</li>
                <li>{{ income.number }} 个</li>
                <li>{{ formatNumber(income.totalPrice / income.number || 0) }} 元</li>
                <li>{{ formatNumber(income.maoriForehead | 0) }} 元</li>
                <li>{{ formatNumber(income.grossProfitMargin * 100 || 0) }} %</li>
              </ul>
            </div>
          </div>
          <div class="table-item">
            <div class="left">
              <span class="iconfont icon-income-o"></span>
              <h3>收费明细</h3>
            </div>
            <div class="right">
              <ul>
                <li>馆内处方收入</li>
                <li>外来处方收入</li>
                <li>拍单收入</li>
                <li>理疗费收入</li>
                <li>加工费收入</li>
                <li>配送费收入</li>
              </ul>
              <ul>
                <li>{{ formatNumber(income.deptPrice || 0) }} 元 ({{ formatNumber(income.deptPrice / income.totalPrice *
                  100
                  || 0) }} %)</li>
                <li>{{ formatNumber(income.outsidePrice || 0) }} 元 ({{ formatNumber(income.outsidePrice /
                  income.totalPrice *
                  100 || 0) }} %)</li>
                <li>{{ formatNumber(income.wechatPrice || 0) }} 元 ({{ formatNumber(income.wechatPrice / income.totalPrice
                  *
                  100 || 0) }} %)</li>
                <li>{{ formatNumber(income.physioPrice || 0) }} 元 ({{ formatNumber(income.physioPrice / income.totalPrice
                  *
                  100 || 0) }} %)</li>
                <li>{{ formatNumber(income.processingPrice || 0) }} 元 ({{ formatNumber(income.processingPrice /
                  income.totalPrice * 100 || 0) }} %)</li>
                <li>{{ formatNumber(income.deliveryPrice || 0) }} 元 ({{ formatNumber(income.deliveryPrice /
                  income.totalPrice
                  * 100 || 0) }} %)</li>
              </ul>
            </div>
          </div>
          <div class="table-item">
            <div class="left">
              <span class="iconfont icon-keliuqushi"></span>
              <h3>客流趋势</h3>
            </div>
            <div class="right">
              <ul>
                <li>导医推荐新增</li>
                <li>总挂号数</li>
                <li>未签到数</li>
                <li>退号数</li>
                <li>跑单数</li>
                <li>实际到馆数</li>
              </ul>
              <ul>
                <li>{{ passengerFlow.recommendNumber }} 个</li>
                <li>{{ passengerFlow.registerNumber }} 个</li>
                <li>{{ passengerFlow.noSignNumber }} 个</li>
                <li>{{ passengerFlow.cancelNumber }} 个</li>
                <li>{{ passengerFlow.runRegisterOrderNumber + passengerFlow.runPaymentOrderNumber }} 个</li>
                <li>{{ passengerFlow.arriveDeptNumber }} 个</li>
              </ul>
            </div>
          </div>
        </div> -->
      <!-- 饼图数据 -->
      <!-- <div class="pie">
          <div class="pie-item">
            <div class="title">销售目录</div>
            <echarts-pie :options="saleOptions" class="pie-img"></echarts-pie>
          </div>
          <div class="pie-item">
            <div class="title">收费方式</div>
            <echarts-pie :options="chargeOptions" class="pie-img"></echarts-pie>
          </div>
        </div>
      </div> -->
      <!-- 医生数据看板 -->
      <!-- <h3 class="page">医生数据</h3>
      <div class="page section">
        <el-button type="text" @click="getDoctorData(time.today, time.today)">今天</el-button>
        <el-button type="text" @click="getDoctorData(time.yesterday, time.yesterday)">昨天</el-button>
        <el-button type="text" @click="getDoctorData(time.monday, time.sunday)">本周</el-button>
        <el-button type="text" @click="getDoctorData(time.firstday, time.lastday)">本月</el-button>
        <el-date-picker v-model="timeRange" type="daterange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" value-format="yyyy-MM-dd" />
        <el-button type="primary" @click="getDoctorData(timeRange[0], timeRange[1])"
          :disabled="timeRange == ''">查询</el-button> -->
      <!-- 表格数据 -->
      <!-- <el-table class="page" :data="doctorData" show-summary :summary-method="summary0" :max-height="tableHeight"
          border>
          <el-table-column prop="doctorName" label="医生姓名" width="150" />
          <el-table-column prop="outpatientNumber" label="门诊总数(个)" />
          <el-table-column prop="diagnoseNumber" label="已看诊数(个)" />
          <el-table-column prop="totalPrice" label="销售金额(不含挂号费)(元)" min-width="200" />
          <el-table-column prop="price" label="客单价(元)" />
          <el-table-column prop="runOrderNumber" label="跑单数(个)" />
        </el-table> -->
      <!-- 分页 -->
      <!-- <el-pagination class="page position-s" @current-change="handleCurrentChange" :total="total"
          :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" />
      </div> -->
      <!-- 医馆数据看板 -->
      <!-- <h3 class="page" v-if="deptName == '总部'">医馆数据</h3>
      <div class="page section" v-if="deptName == '总部'">
        <el-button type="text" @click="getDeptData(time.today, time.today)">今天</el-button>
        <el-button type="text" @click="getDeptData(time.yesterday, time.yesterday)">昨天</el-button>
        <el-button type="text" @click="getDeptData(time.monday, time.sunday)">本周</el-button>
        <el-button type="text" @click="getDeptData(time.firstday, time.lastday)">本月</el-button>
        <el-date-picker v-model="timeRange" type="daterange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" value-format="yyyy-MM-dd" />
        <el-button type="primary" @click="getDeptData(timeRange[0], timeRange[1])"
          :disabled="timeRange == ''">查询</el-button> -->
      <!-- 表格数据 -->
      <!-- <el-table class="page" :data="deptData" show-summary :summary-method="summary" :max-height="tableHeight" border>
          <el-table-column prop="deptName" label="医馆简称" min-width="100" />
          <el-table-column prop="outpatientNumber" label="门诊总数(个)" min-width="100" />
          <el-table-column prop="totalPrice" label="销售金额(不含挂号费)(元)" min-width="200" />
          <el-table-column prop="price" label="客单价(元)" />
          <el-table-column prop="runOrderNumber" label="跑单数(个)" />
        </el-table>
      </div> -->
      <div v-if="isDoctor">
        <!-- 号源看板 -->
        <div v-loading="numberLoading">
          <h3 class="page">号源看板</h3>
          <div class="page section">
            <el-button type="primary" @click="getNumberSource(1)">今天</el-button>
            <el-button type="primary" @click="getNumberSource(2)">明天</el-button>
            <el-button type="primary" @click="getNumberSource(3)">后天</el-button>
            <el-date-picker class="ml10" v-model="numberTimeRange" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp" />
            <el-button type="primary" @click="getNumberSource(4, numberTimeRange[0], numberTimeRange[1])">查询</el-button>
            <div class="display-f align-i-c mt16">
              <h4>挂号概况</h4>
              <div v-for="item in numberInfo.register" :key="item.type" class="numBox border2"
                :class="item.type == 1 ? 'backE8F' : item.type == 2 ? 'back0E1' : 'backFEE'" style="">
                <div class="font600">{{ item.type == 1 ? '预约号数' : item.type == 2 ? '退号数' : '停诊号数' }}</div>
                <div class="font500 mt16" :class="item.type == 1 ? 'color189' : item.type == 2 ? 'colorFE8' : 'colorF54'"
                  style="font-size: 18px;">{{ item.total }}</div>
                <div class="display-f mt10 size13">
                  <div v-if="item.total == 0">--</div>
                  <div v-if="item.registerItem.ordinaryNum > 0">普通({{ item.registerItem.ordinaryNum }})</div>
                  <div class="ml5" v-if="item.registerItem.orderSpecialNum > 0">特约({{ item.registerItem.orderSpecialNum
                  }})
                  </div>
                  <div class="ml5" v-if="item.registerItem.physicalNum > 0">理疗({{ item.registerItem.physicalNum }})</div>
                  <div class="ml5" v-if="item.registerItem.freeClinicNum > 0">义诊({{ item.registerItem.freeClinicNum }})
                  </div>

                </div>
              </div>

            </div>
            <div class="display-f align-i-c mt16">
              <h4>签到概况</h4>
              <div class="right">
                <ul>
                  <li>待签到</li>
                  <li>已签到</li>
                </ul>
                <ul>
                  <li>{{ numberInfo.sign.waitSignNum }}</li>
                  <li>{{ numberInfo.sign.signedNum }}</li>
                </ul>
              </div>
              <h4>就诊概况</h4>
              <div class="right">
                <ul>
                  <li>待就诊</li>
                  <li>已就诊</li>
                </ul>
                <ul>
                  <li>{{ numberInfo.treat.waitTreatNum }}</li>
                  <li>{{ numberInfo.treat.treatedNum }}</li>
                </ul>
              </div>
            </div>

          </div>
          <!-- 表格数据 -->
          <el-table class="page" :data="numberList" :max-height="tableHeight" border>
            <el-table-column type="index" label="序号" />
            <el-table-column prop="patientName" label="患者姓名" />
            <el-table-column prop="sex" label="性别" />
            <el-table-column prop="phone" label="手机号" />
            <el-table-column prop="orderNumber" label="订单号" />
            <el-table-column prop="status" label="状态" />
            <el-table-column prop="realPay" label="挂号费/元" />
            <el-table-column prop="source" label="渠道" />
            <el-table-column prop="schedulingTime" label="预约时间" />
            <el-table-column prop="timeQuantumName" label="预约班次" />
            <el-table-column prop="signSort" label="签到排序" />
          </el-table>
          <!-- 分页 -->
          <el-pagination class="page position-s" @current-change="handleCurrentChangeNum" :total="numTotal"
            :current-page="numPages.currentPage" :page-size="numPages.pageSize"
            layout="total, prev, pager, next, jumper" />

        </div>
        <!-- 诊断看板 -->
        <div v-loading="diagnoseLoading">

          <h3 class="page">诊断看板</h3>
          <div class="page section">
            <el-button type="primary" @click="getDiagnoseSource(1)">今天</el-button>
            <el-button type="primary" @click="getDiagnoseSource(2)">昨天</el-button>
            <el-button type="primary" @click="getDiagnoseSource(3)">本周</el-button>
            <el-date-picker class="ml10" v-model="diagnoseTimeRange" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp" />
            <el-button type="primary"
              @click="getDiagnoseSource(4, diagnoseTimeRange[0], diagnoseTimeRange[1])">查询</el-button>

            <div class="display-f align-i-c mt16">
              <div class="right" style="margin-left: 0px;">
                <ul>
                  <li>已接门诊人次</li>
                  <li>已接网诊人次</li>
                  <li>已开处方数量</li>
                  <li>已支付订单金额</li>
                  <li>计提金额</li>
                </ul>
                <ul>
                  <li>{{ diagnoseInfo.doorDiagnoseNum }}</li>
                  <li>{{ diagnoseInfo.webDiagnoseNum }}</li>
                  <li>{{ diagnoseInfo.prescribeNum }}</li>
                  <li>{{ diagnoseInfo.orderMoney }}</li>
                  <li>{{ diagnoseInfo.provisionMoney }}</li>
                </ul>
              </div>
            </div>

          </div>
          <!-- 表格数据 -->
          <el-table class="page" :data="diagnoseList" :max-height="tableHeight" border>
            <el-table-column type="index" label="序号" />
            <el-table-column prop="patientName" label="患者姓名" />
            <el-table-column prop="orderNumber" label="订单号" />
            <el-table-column prop="status" label="状态" />
            <el-table-column prop="paymentRealPay" label="总费用">
              <template slot-scope="scope">
                {{ scope.row.paymentRealPay ? scope.row.paymentRealPay : 0 }}
              </template>
            </el-table-column>
            <el-table-column prop="replenishRegisterMoney" label="补录挂号费">
              <template slot-scope="scope">
                {{ scope.row.replenishRegisterMoney ? scope.row.replenishRegisterMoney : 0 }}
              </template>
            </el-table-column>
            <el-table-column prop="drugPrice" label="中药处方费">
              <template slot-scope="scope">
                {{ scope.row.drugPrice ? scope.row.drugPrice : 0 }}
              </template>
            </el-table-column>
            <el-table-column prop="comboPrice" label="隐秘处方费">
              <template slot-scope="scope">
                {{ scope.row.comboPrice ? scope.row.comboPrice : 0 }}
              </template>
            </el-table-column>
            <el-table-column prop="physioPrice" label="理疗处方费">
              <template slot-scope="scope">
                {{ scope.row.physioPrice ? scope.row.physioPrice : 0 }}
              </template>
            </el-table-column>
            <el-table-column prop="processingPrice" label="加工费">
              <template slot-scope="scope">
                {{ scope.row.processingPrice ? scope.row.processingPrice : 0 }}
              </template>
            </el-table-column>
            <el-table-column prop="otherPrice" label="其他商品费">
              <template slot-scope="scope">
                {{ scope.row.otherPrice ? scope.row.otherPrice : 0 }}
              </template>
            </el-table-column>
            <el-table-column prop="deliveryPrice" label="配送费">
              <template slot-scope="scope">
                {{ scope.row.deliveryPrice ? scope.row.deliveryPrice : 0 }}
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination class="page position-s" @current-change="handleCurrentChangeDia" :total="diaTotal"
            :current-page="diaPages.currentPage" :page-size="diaPages.pageSize"
            layout="total, prev, pager, next, jumper" />
        </div>
      </div>
    </div>
  </Card>
</template>

<script lang="js">
import { businessStatistical, doctorData, deptData, yibaoUpLoad, registerListApi, registerInfoApi, diagnoseOverviewApi, diagnoseOverviewListApi } from "@/api/home"; // 首页数据请求
import EchartsPie from "@/components/EchartsPie"; // 引入饼状图组件
import { roleList } from '@/utils/const.js'
import { CommonDTO } from '@/DTO/index'
export default {
  name: "Home",
  components: { EchartsPie },
  data() {
    return {
      deptId: null, // 医馆id
      deptName: null, // 医馆名称
      userName: null, // 用户名称
      loading: true, // 加载状态
      timeSlot: null, // 时间段
      dateStr: '今天是', // 日期字符串
      timeRange: '', // 查询时间段
      time: {
        today: null, // 今天
        yesterday: null, // 昨天
        monday: null, // 星期一
        sunday: null, // 星期日
        firstday: null, // 本月1号
        lastday: null, // 本月最后一天
        tomorrow: null,//明天
      },
      income: {}, // 收入
      passengerFlow: {}, // 客流
      saleOptions: {}, // 销售图表数据
      chargeOptions: {}, // 收费方式数据
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      startTime: null, // 开始时间
      endTime: null, // 结束时间
      doctorData: [], // 医生数据
      deptData: [], // 医馆数据
      tableHeight: 600, // 表格最大高度

      // 新加医生看板
      roleList: roleList,
      isDoctor: false,
      numberTimeRange: [],
      numberData: {//号源搜索条件
        type: 1,
        startTime: null,
        endTime: null,

      },
      numPages: {
        currentPage: 1,
        pageSize: 10,
      },
      numberList: [],//号源列表
      numberInfo: {},//号源信息
      numTotal: 0,
      numberLoading: false,
      diagnoseTimeRange: [],
      diagnoseData: {//诊断搜索条件
        type: 1,
        startTime: null,
        endTime: null,
      },
      diaPages: {
        currentPage: 1,
        pageSize: 10,
      },
      diagnoseList: [],//诊断列表
      diaTotal: 0,
      diagnoseInfo: {},//诊断信息
      diagnoseLoading: false,

    }
  },
  async created() {
    this.systemTime = CommonDTO.getSystemTimeDTO()
    this.tableHeight = document.documentElement.clientHeight - 240;
    // 获取医馆信息
    this.deptId = this.$session.get('deptId');
    this.$session.get('options').forEach(item => { if (item.value == this.deptId) this.deptName = item.label });
    this.userName = this.$session.get('user').nickName; // 获取用户昵称
    this.computeDate(); // 计算时间
    this.getStatistical(this.time.today, this.time.today); // 获取经营统计数据
    this.getDoctorData(this.time.today, this.time.today); // 获取医生数据
    // 有总部权限获取医馆数据
    let flag = null;
    this.$session.get('options').forEach(item => {
      if ([0,-1].includes(item.value)) flag = true;
    });
    if (flag == true) this.getDeptData(this.time.today, this.time.today);
    this.getRole()

  },
  //监听属性 类似于data概念
  computed: {
    formatNumber() {
      let self = this;
      return function (val) {
        // 对计算属性进行传参
        if (val) {
          return self.$toFixed(val);
        }
      };
    },
  },
  methods: {
    // 计算时间
    computeDate() {
      const date = new Date(this.systemTime);
      const hour = date.getHours();
      // 判断时间段
      switch (true) {
        case hour >= 3 && hour < 6: this.timeSlot = '凌晨'; break;
        case hour >= 6 && hour < 8: this.timeSlot = '早上'; break;
        case hour >= 8 && hour < 11: this.timeSlot = '上午'; break;
        case hour >= 11 && hour < 13: this.timeSlot = '中午'; break;
        case hour >= 13 && hour < 17: this.timeSlot = '下午'; break;
        case hour >= 17 && hour < 19: this.timeSlot = '傍晚'; break;
        case hour >= 19 && hour < 23: this.timeSlot = '晚上'; break;
        case (hour >= 23 && hour < 24) || (hour >= 0 && hour < 3): this.timeSlot = '深夜'; break;
      }
      // 年月日赋值
      let year = date.getFullYear(), month = this.zeroAdd(date.getMonth() + 1), day = this.zeroAdd(date.getDate());
      // 判断一个月多少天
      let num = null;
      [1, 3, 5, 7, 8, 10, 12].forEach(item => { if (month == item) num = 31; });
      [4, 6, 9, 11].forEach(item => { if (month == item) num = 30 });
      if (month == 2 && (year % 4 == 0)) num = 29;
      else if (month == 2 && (year % 4 != 0)) num = 28;
      // 计算昨天时间
      const date1 = new Date(date.getTime() - 24 * 60 * 60 * 1000);
      // 拼接日期字符串
      this.dateStr += ` ${year} 年 ${month} 月 ${day} 日
      星期${['日', '一', '二', '三', '四', '五', '六'][date.getDay()]}`;
      // 日期赋值
      this.time.today = `${year}-${month}-${day}`; // 今天
      this.time.yesterday = `${date1.getFullYear()}-${this.zeroAdd(date1.getMonth() + 1)}-${this.zeroAdd(date1.getDate())}`; // 昨天
      this.time.monday = this.$timeRange.week[0]; // 星期一
      this.time.sunday = this.$timeRange.week[6]; // 星期日
      this.time.firstday = `${year}-${month}-01`; // 本月1号
      this.time.lastday = `${year}-${month}-${num}`; // 本月最后一天
      this.time.tomorrow = this.$moment().add(1, 'days').format("YYYY-MM-DD");//明天
    },
    // 月、日不足10补0
    zeroAdd(num) {
      num >= 10 ? num : num = '0' + num;
      return num;
    },
    // 获取经营统计数据
    async getStatistical(startTime, endTime) {
      this.loading = true;
      let { code, data } = await businessStatistical({ deptId: this.deptId, startTime: startTime, endTime: endTime });
      if (code == 200) {
        for (let key in data.income) {
          if (data.income[key] == null) data.income[key] = 0;
        }
        for (let key in data.passengerFlow) {
          if (data.passengerFlow[key] == null) data.passengerFlow[key] = 0;
        }
        this.income = data.income;
        this.passengerFlow = data.passengerFlow;

        let sale = data.salesCatalog, income = data.income, charge = data.wayCharge;
        if (sale == null) sale = { slicesPrice: 0, registerPrice: 0, particlesPrice: 0 };
        else for (let key in sale) {
          if (sale[key] == null) sale[key] = 0;
        }
        if (charge == null) charge = { wechatPrice: 0, aliPrice: 0, cashPrice: 0, socialSecurityPrice: 0 };
        else for (let key in charge) {
          if (charge[key] == null) charge[key] = 0;
        }
        let totalPrice = sale.registerPrice + sale.slicesPrice + sale.particlesPrice + income.physioPrice + income.processingPrice + income.deliveryPrice;
        this.saleOptions = {
          toolTitle: '销售类型/销售金额',
          data: [
            { value: this.$toFixed(sale.registerPrice / totalPrice || 0), name: "挂号费(" + this.$toFixed(sale.registerPrice) + '元)' },
            { value: this.$toFixed(sale.slicesPrice / totalPrice || 0), name: "中药饮片(" + this.$toFixed(sale.slicesPrice) + '元)' },
            { value: this.$toFixed(sale.particlesPrice / totalPrice || 0), name: "中药颗粒(" + this.$toFixed(sale.particlesPrice) + '元)' },
            { value: this.$toFixed(income.physioPrice / totalPrice || 0), name: "理疗费(" + this.$toFixed(income.physioPrice) + '元)' },
            { value: this.$toFixed(income.processingPrice / totalPrice || 0), name: "加工费(" + this.$toFixed(income.processingPrice) + '元)' },
            { value: this.$toFixed(income.deliveryPrice / totalPrice || 0), name: "配送费(" + this.$toFixed(income.deliveryPrice) + '元)' },
          ]
        }
        this.chargeOptions = {
          toolTitle: '收费方式/收费金额',
          data: [
            { value: this.$toFixed(charge.wechatPrice / totalPrice || 0), name: "微信(" + this.$toFixed(charge.wechatPrice || 0) + '元)' },
            { value: this.$toFixed(charge.cashPrice / totalPrice || 0), name: "现金(" + this.$toFixed(charge.cashPrice || 0) + '元)' },
            { value: this.$toFixed(charge.aliPrice / totalPrice || 0), name: "支付宝(" + this.$toFixed(charge.aliPrice || 0) + '元)' },
            { value: this.$toFixed(charge.socialSecurityPrice / totalPrice || 0), name: "医保卡(" + this.$toFixed(charge.socialSecurityPrice || 0) + '元)' },
            { value: this.$toFixed(charge.bankCardPrice / totalPrice || 0), name: "银行卡(" + this.$toFixed(charge.bankCardPrice || 0) + '元)' }
          ]
        }

      }
      this.loading = false;
    },
    // 获取医生数据
    async getDoctorData(startTime, endTime) {
      this.startTime = startTime;
      this.endTime = endTime;
      this.loading = true;
      let { total, rows, code } = await doctorData({ pageNum: this.currentPage, pageSize: this.pageSize, startTime: startTime, endTime: endTime });
      if (code == 200) {
        this.total = total;
        if (total > 0) rows.forEach(item => {
          item.outpatientNumber == null ? item.outpatientNumber = 0 : item.outpatientNumber;
          item.diagnoseNumber == null ? item.diagnoseNumber = 0 : item.diagnoseNumber;
          item.totalPrice == null ? item.totalPrice = '0.00' : item.totalPrice = this.$toFixed(item.totalPrice);
          item.runOrderNumber == null ? item.runOrderNumber = 0 : item.runOrderNumber;
          item.price = this.$toFixed(item.totalPrice / item.diagnoseNumber | 0);
        })
        this.doctorData = rows;
      }
      this.loading = false;
    },
    // 获取医馆数据
    async getDeptData(startTime, endTime) {
      let { data, code } = await deptData({ startTime: startTime, endTime: endTime });
      if (code == 200) {
        data.forEach(item => {
          item.outpatientNumber == null ? item.outpatientNumber = 0 : item.outpatientNumber;
          item.totalPrice == null ? item.totalPrice = '0.00' : item.totalPrice = this.$toFixed(item.totalPrice);
          item.runOrderNumber == null ? item.runOrderNumber = 0 : item.runOrderNumber;
          item.price = this.$toFixed(item.totalPrice / item.outpatientNumber | 0);
        })
        this.deptData = data;
      }
    },
    // 刷新数据
    refresh() {
      this.loading = true;
      this.getStatistical(this.time.today, this.time.today);
      this.getDoctorData(this.time.today, this.time.today);
      if ([0,-1].includes(this.deptId)) this.getDeptData(this.time.today, this.time.today); // 获取医馆数据
    },
    // 当前页改变
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getDoctorData(this.startTime, this.endTime);
    },
    // 求和公式
    summary0(params) {
      const { columns, data } = params;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index];
        }
      });
      sums[4] = this.$toFixed((sums[3] / sums[1]) | 0) + ' 元';
      sums[1] = sums[1] + ' 个';
      sums[2] = sums[2] + ' 个';
      sums[3] = sums[3] + ' 元';
      sums[5] = sums[5] + ' 个';
      return sums;
    },
    summary(params) {
      const { columns, data } = params;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index];
        }
      });
      sums[3] = this.$toFixed(sums[2] / sums[1]) + ' 元';
      sums[1] = sums[1] + ' 个';
      sums[2] = sums[2] + ' 元';
      sums[4] = sums[4] + ' 个';
      return sums;
    },

    // 临时数据批量上传
    // upload() {
    //   let list = [];
    //   this.$temporaryList.forEach(item => {
    //     let {
    //       indications, guijing, shebaoCode, usage2, name, effectCategory,
    //       chrgitmLv, method, xingwei
    //     } = item;
    //     list.push({
    //       attending: indications, channelTropism: guijing, dictDrugCode: shebaoCode,
    //       drugMethod: usage2, drugName: name, effectType: effectCategory, mtType: chrgitmLv,
    //       processingMethod: method, propertyFlavor: xingwei
    //     })
    //   })
    //   yibaoUpLoad(list).then(res => {
    //     if (res.code == 200) this.$message.success('保存成功！');
    //   })
    // }

    //号源看板
    getNumberSource(type = 1, start, end) {
      this.numberData.type = type;
      if (start) {
        this.numberData.startTime = start
      }
      if (end) {
        this.numberData.endTime = end
      }
      if (type != 4) {
        this.numberTimeRange = [];
        this.numberData.startTime = null;
        this.numberData.endTime = null;
      }
      this.numPages.currentPage = 1
      this.getNumberList()
      this.getNumberInfo()
    },
    async getNumberList() {
      this.numberLoading = true
      let obj = {
        ...this.numberData,
        ...this.numPages
      }
      let regRes = await registerListApi(obj)
      if (regRes.code == 200) {
        this.numberList = regRes.rows
        this.numTotal = regRes.total
      }
      this.numberLoading = false
    },
    async getNumberInfo() {
      let InfoRes = await registerInfoApi(this.numberData)
      if (InfoRes.code == 200) {
        InfoRes.data.register.forEach(item => {
          item.total = Number(item.registerItem.freeClinicNum) + Number(item.registerItem.orderSpecialNum) + Number(item.registerItem.ordinaryNum) + Number(item.registerItem.physicalNum)
        })
        this.numberInfo = InfoRes.data
      }
    },
    //诊断看板
    getDiagnoseSource(type = 1, start, end) {
      this.diagnoseData.type = type;
      if (start) {
        this.diagnoseData.startTime = start
      }
      if (end) {
        this.diagnoseData.endTime = end
      }
      if (type != 4) {
        this.diagnoseTimeRange = [];
        this.diagnoseData.startTime = null;
        this.diagnoseData.endTime = null;
      }
      this.diaPages.currentPage = 1;
      this.getDiagnoseInfo()
      this.getDiagnoseList()
    },
    async getDiagnoseInfo() {
      let DiaRes = await diagnoseOverviewApi(this.diagnoseData)
      if (DiaRes.code == 200) {
        this.diagnoseInfo = DiaRes.data
      }

    },
    async getDiagnoseList() {
      this.diagnoseLoading = true
      let obj = {
        ...this.diagnoseData,
        ...this.diaPages
      }
      let ListRes = await diagnoseOverviewListApi(obj)
      if (ListRes.code == 200) {
        this.diagnoseList = ListRes.rows
        this.diaTotal = ListRes.total
      }
      this.diagnoseLoading = false

    },
    //获取是否是医生
    getRole() {
      let roles = this.$session.get('roles');
      this.isDoctor = roles.some(val => val == 'Doctor')
      if (this.isDoctor) {
        this.getNumberSource()
        this.getDiagnoseSource()
      }
    },
    handleCurrentChangeNum(val) {
      this.numPages.currentPage = val;
      this.getNumberList()
    },
    handleCurrentChangeDia(val) {
      this.diaPages.currentPage = val;
      this.getDiagnoseList()
    }
  }
};
</script>

<style lang="less" scoped>
.el-card {
  /deep/.el-card__header {
    h3 {
      font-family: '华文楷体' !important
    }
  }

  /deep/.el-card__body {
    overflow-y: scroll;

    .homewrap {
      .section {
        .el-button--text {
          font-size: 16px;
          margin-right: 10px;
        }

        .el-startTime-editor {
          margin-left: 10px;
        }

        .el-date-editor+.el-button--primary {
          margin-left: 10px;
          position: relative;
          top: -1px;
        }

        // 表格数据样式
        .table-list {
          .table-item {
            display: flex;
            align-items: center;
            margin-top: 30px;

            .left {
              text-align: center;

              .iconfont {
                display: block;
                margin-bottom: 10px;
                font-size: 40px;

              }
            }

            &:first-child {
              .left {
                .iconfont {
                  font-size: 56px;
                  line-height: 40px;
                  margin-bottom: 15px;
                }
              }
            }

            .right {
              margin-left: 30px;
              flex: 1;

              ul {
                display: flex;

                li {
                  font-size: 14px;
                  flex: 1;
                  height: 40px;
                  line-height: 40px;
                  text-align: center;
                  border: 1px solid #e6e6e6;

                  &:not(:last-child) {
                    border-right: none;
                  }
                }

                &:first-child {
                  li {
                    border-bottom: none;
                  }
                }
              }

            }
          }
        }

        /* 饼图数据样式 */
        .pie {
          margin-top: 30px;
          display: flex;

          .pie-item {
            flex: 1;
            font-weight: bold;
            border: 1px solid #e6e6e6;

            .title {
              padding-left: 10px;
              line-height: 40px;
              background-color: #e6e6e6;

            }

            &:first-child {
              margin-right: 20px;
            }

            .pie-img {
              height: 250px;
              padding-top: 15px;
            }
          }
        }
      }
    }
  }
}

.numBox {
  margin-left: 30px;
  width: 236px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  padding: 10px;
  box-sizing: border-box;
}

.right {
  margin-left: 30px;
  margin-right: 30px;

  ul {
    display: flex;

    li {
      width: 175px;
      font-size: 14px;
      flex: 1;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border: 1px solid #e6e6e6;

      &:not(:last-child) {
        border-right: none;
      }
    }

    &:first-child {
      li {
        border-bottom: none;
      }
    }
  }

}

.backE8F {
  background-color: #E8F4FF;
}

.back0E1 {
  background-color: #FFF0E1;
}

.backFEE {
  background-color: #FEE6E5;
}

/deep/ .el-table th.el-table__cell {
  background-color: #F0F1F3;
}</style>